{
  "$vuetify": {
    "badge": "Badge",
    "noDataText": "No data available",
    "close": "Close",
    "open": "Open",
    "loading": "Loading",
    "dataIterator": {
      "loadingText": "Loading..."
    },
    "carousel": {
      "ariaLabel": {
        "delimiter": "slide"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "Items per page:",
      "itemsPerPageAll": "All",
      "pageText": "{0}-{1} of {2}",
      "firstPage": "First Page",
      "prevPage": "Previous Page",
      "nextPage": "Next Page",
      "lastPage": "Last Page"
    },
    "pagination": {
      "showing": "Showing {0} to {1} of {2} entries",
      "ariaLabel": {
        "root": "Pagination Navigation",
        "previous": "Previous",
        "first": "First",
        "last": "Last",
        "next": "Next",
        "currentPage": "Current Page",
        "page": "Page"
      }
    },
    "input": {
      "clear": "Clear",
      "appendAction": "Append action",
      "prependAction": "Prepend action",
      "counterSize": "Counter size",
      "otp": "One-time password"
    },
    "fileInput": {
      "counterSize": "Counter size"
    },
    "rating": {
      "ariaLabel": {
        "item": "Item"
      }
    },
    "datePicker": {
      "header": "Select Date",
      "items": [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "weekdays": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "weekdaysShort": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ]
    },
    "colorPicker": {
      "ariaLabel": {
        "eyedropper": "Eyedropper",
        "hexInput": "HEX Input",
        "hueSlider": "Hue Slider"
      }
    }
  },
  "Validation": {
    "required": "This field is required",
    "email": "The Email field must be a valid email",
    "password": "Field must contain at least one uppercase, lowercase, special character and digit with min 8 chars",
    "confirmed": "The Confirm Password field confirmation does not match",
    "phone": "Invalid phone number format",
    "regex": "The Regex field format is invalid",
    "alpha": "The Alpha field may only contain alphabetic characters",
    "url": "URL is invalid",
    "length": "The length of the Characters field must be {length} characters.",
    "alphaDash": "All Character are not valid",
    "time": "Invalid time format",
    "lengthMax": "Enter at most {length} characters",
    "lengthBetween": "Enter characters between {min} and {max}",
    "integer": "This field must be an integer.",
    "decimal": "This field must be a decimal.",
    "validNumber": "Enter a valid number.",
    "min": "Enter a value greater than or equal to {min}.",
    "max": "Enter a value less than or equal to {max}.",
    "lengthMin": "Enter at least {length} characters",
    "between": "Enter a number between {min} and {max}.",
    "minTwoFields": "At least one value must be {min} or greater.",
    "sase": "Chassis is not valid",
    "startDateInline": "Start Date cannot be after {target}",
    "endDateInline": "End Date cannot be before {target}"
  },
  "activeOptions": {
    "Hepsi": "All",
    "Aktif": "Active",
    "Pasif": "Passive"
  },
  "projeFaturaTipList": {
    "Kısmı": "Partial",
    "Tam": "Full"
  },
  "musteriTip": {
    "Alış-Satış": "Buy-Sell",
    "Alış": "Purchase",
    "Satış": "Sale"
  },
  "paraTur": {
    "TL": "TL",
    "Euro": "Euro",
    "Dolar": "Dollar"
  },
  "satisDurum": {
    "Onayli": "Approved",
    "Bekliyor": "Pending",
    "Iptal": "Cancelled",
    "Cayma": "Withdrawal"
  },
  "satisTip": {
    "Yok": "None",
    "case2": "case2",
    "case3": "case3"
  },
  "odemeSekli": {
    "1 Aylık": "1 Month",
    "3 Aylık": "3 Months",
    "6 Aylık": "6 Months",
    "12 Aylık": "12 Months"
  },
  "projeHourTypesList": {
    "Seçiniz": "Select",
    "General hours": "General Hours",
    "AI-IS AI Models": "AI-IS AI Models",
    "AI-IS MM support": "AI-IS MM Support",
    "AI-IS Commercial": "AI-IS Commercial",
    "AI-IS Non-commercial": "AI-IS Non-commercial",
    "Bee4GIS Commercial": "Bee4GIS Commercial",
    "Bee4GIS Non-commercial": "Bee4GIS Non-commercial"
  },
  "projeAltStatusList": {
    "Bekliyor": "Pending",
    "İşlemde": "In Progress",
    "Bitti": "Completed"
  },
  "projeAltStatusAdminList": {
    "Bekliyor": "Pending",
    "İşlemde": "In Progress",
    "Bitti": "Completed",
    "Gönderildi": "Sent",
    "Onay": "Approved",
    "Kapalı": "Closed"
  },
  "projeAltUcretTurList": {
    "Seçiniz": "Select",
    "KM Fiyat": "KM Price",
    "Saat Fiyat": "Hourly Rate",
    "Sabit Fiyat": "Fixed Price",
    "Adet Fiyat": "Unit Price"
  },
  "medenidurumListe": {
    "Bilinmiyor": "Unknown",
    "Bekar": "Single",
    "Evli": "Married",
    "Boşanmış": "Divorced",
    "Dul": "Widowed"
  },
  "ogrenimListe": {
    "Bilinmiyor": "Unknown",
    "İlköğretim": "Primary Education",
    "Ortaöğretim": "Secondary Education",
    "Lise": "High School",
    "ÖnLisans": "Associate Degree",
    "Lisans": "Bachelor's Degree",
    "Yüksek Lisans": "Master's Degree",
    "Doktora": "PhD"
  },
  "kangrubuListe": {
    "Bilinmiyor": "Unknown",
    "A+": "A+",
    "A-": "A-",
    "B+": "B+",
    "B-": "B-",
    "AB+": "AB+",
    "AB-": "AB-",
    "0+": "0+",
    "0-": "0-"
  },
  "cinsiyetListe": {
    "Bilinmiyor": "Unknown",
    "Erkek": "Male",
    "Kadın": "Female"
  },
  "egitimTurList": {
    "Diploma": "Diploma",
    "Sertifika": "Certificate",
    "Belge": "Document",
    "Öğrenci": "Student"
  },
  "izinTurList": {
    "Yıllık ücretli izin": "Annual Paid Leave",
    "Ücretsiz izin": "Unpaid Leave",
    "Mazeret izni": "Excused Leave",
    "Diğer izinler": "Other Leaves",
    "Rapor": "Report"
  },
  "izinTurGetList": {
    "Yıllık ücretli girişi": "Annual Paid Entry",
    "Yıllık ücretli izin": "Annual Paid Leave",
    "Ücretsiz izin": "Unpaid Leave",
    "Mazeret izni": "Excused Leave",
    "Diğer izinler": "Other Leaves",
    "Rapor": "Report"
  },
  "envanterStatusList": {
    "Yeni": "New",
    "Aktif": "Active",
    "Zimmet": "Assigned Asset",
    "Tamirde": "In Repair",
    "Depoda": "In Storage",
    "Demirbaş": "Fixture",
    "Kayıp": "Lost",
    "Pasif": "Passive",
    "Satıldı": "Sold",
    "Hurda": "Scrap",
    "Diğer": "Other"
  },
  "komisyon_tur_liste": {
    "Komisyonsuz": "No Commission",
    "Ape Komisyon": "Ape Commission",
    "Sm Ape Komisyon": "Sm Ape Commission"
  },
  "yemekKartiTipi": {
    "Yok": "None",
    "Mobil": "Mobile",
    "Fiziksel": "Physical"
  },
  "Acil Durum": "Emergency Contact",
  "Ad": "Name",
  "Ad Soyad": "Full Name",
  "Ad daha önceden kayıt edilmiş.": "Name already registered.",
  "Adet": "Quantity",
  "Adres": "Address",
  "Aktif Kayıt": "Active Record",
  "Aktif/Pasif": "Active/Passive",
  "Ana Sayfa": "Dashboard",
  "Anket Başarıyla Gönderildi": "Survey submitted successfully.",
  "Anket Başlığı": "Survey Title",
  "Anket Bilgileri": "Survey Information",
  "Anket Cevapları": "Survey Responses",
  "Anket Listesi": "Survey List",
  "Anket Oluştur": "Create Survey",
  "Anket Public": "Public Survey",
  "Anket Silindi": "Survey successfully deleted.",
  "Anket Sonuçları": "Survey Results",
  "Anket Soruları": "Survey Questions",
  "Anket Yönetimi": "Survey Management",
  "Anket cevaplarınız başarıyla kaydedilmiştir.": "Your survey answers have been saved successfully.",
  "Anket cevaplarınız kaydedildi. Teşekkürler!": "Your answers have been saved. Thanks!",
  "Anket silindi.": "Survey deleted.",
  "Anketi Düzenle": "Edit Survey",
  "Anketi Gönder": "Submit Survey",
  "Anketi Sil": "Delete Survey",
  "Anketi Tamamla ve Gönder": "Complete and Submit Survey",
  "Anketi göndermek istediğinize emin misiniz?": "Are you sure you want to submit the survey?",
  "Anketi Çöz": "Take Survey",
  "Anketler": "Surveys",
  "Anketlerim": "My Surveys",
  "Ara": "Search",
  "Ara...": "Search...",
  "Arama": "Search",
  "Ayarları Güncelle": "Update Settings",
  "Aygul Yazılım": "Aygul Software",
  "Aygül Yazılım": "Aygul Software",
  "Az Bulutlu": "Few Clouds",
  "Açık / Güneşli": "Clear / Sunny",
  "Açık Uçlu": "Open Ended",
  "Açık Uçlu (Metin)": "Open Ended (Text)",
  "Açıklama": "Description",
  "Açıklama Metni (Cevapsız)": "Description Text (No Answer)",
  "Banka": "Bank",
  "Barkod": "Barcode",
  "Bas Saat": "Start Time",
  "Baş Saat": "Start Time",
  "Baş.Tarih": "Start Date",
  "Başarılı!": "Success!",
  "Başlangıç": "Start",
  "Başlangıç Saat": "Start Time",
  "Başlangıç Tarih": "Start Date",
  "Başlangıç Tarihi Bitiş Tarihinden sonra olamaz": "Start Date cannot be after End Date",
  "Başlık": "Title",
  "Belge Tür": "Document Type",
  "Bildirim başarıyla gönderildi.": "Notification sent successfully.",
  "Bilgi Notu": "Note",
  "Bilgiler": "Information",
  "Bilgiler Alınıyor": "Fetching Data",
  "Bilgiler Hatalı olabilir kontrol ediniz.": "Information may be incorrect, please check.",
  "Bilinmeyen Konum": "Unknown Location",
  "Bit Saat": "End Time",
  "Bit.Tarih": "End Date",
  "Bitiş": "End",
  "Bitiş Saat": "End Time",
  "Bitiş Saat Başlangıçdan Küçük Olamaz": "End Time cannot be less than Start Time",
  "Bitiş Tarih": "End Date",
  "Bitiş Tarihi Başlangıç Tarihinden önce olamaz": "End Date cannot be before Start Date",
  "Bu alan zorunludur": "This field is required",
  "Bu ankete daha önce katılım sağladınız.": "You have already participated in this survey.",
  "Bu cevabı silmek istediğinize emin misiniz?": "Are you sure you want to delete this answer?",
  "Bu gereksinimlerin karşılandığından emin olun": "Ensure these requirements are met",
  "Bu müşterinin bu kodla kayıtı var.": "This customer already has a record with this code.",
  "Bu soruyu cevaplamanız gerekmektedir.": "You must answer this question.",
  "Bulunamadı, UTC gösteriliyor.": "Not found, showing UTC.",
  "Bölge bulunamadı": "Region not found",
  "Bölüm": "Department",
  "BİLİŞİM": "IT",
  "COMMENT": "COMMENT",
  "Cep": "Mobile",
  "Cevabınız": "Your Answer",
  "Cevap": "Answer",
  "Cevap (Seçenek)": "Answer (Option)",
  "Cevap Detayları": "Response Details",
  "Cevap Sayısı": "Answer Count",
  "Cevap yok": "No answer",
  "Cevaplanmış anketler silinemez.": "Answered surveys cannot be deleted.",
  "Cevaplar": "Answers",
  "Choose": "Choose",
  "Cinsiyet": "Gender",
  "Create an account": "Create an account",
  "DEMİRBAŞ": "FIXTURE",
  "Daha Önce Katıldınız": "Already Participated",
  "Dakika": "Minute",
  "Data Yenile": "Refresh Data",
  "Detay": "Detail",
  "Detayları Gör": "View Details",
  "Doküman Kaydedildi": "Document saved successfully.",
  "Doküman Yüklenemedi": "Error loading document.",
  "Doküman İçeriği": "Document Content",
  "Doğrulama Yöntemi": "Verification Method",
  "Doğrulama kodu gönderilemedi. Lütfen tekrar deneyin.": "Verification code could not be sent. Please try again.",
  "Doğum Tarihi": "Date of Birth",
  "Durum": "Status",
  "Düzeltme": "Edit",
  "Düzenle": "Edit",
  "E-mail": "Email",
  "Ekle": "Add",
  "Eksik Bilgi var. Kontrol ediniz.": "There is missing information. Please check.",
  "Eksik Seçenek": "Missing Option",
  "Email": "Email",
  "Email Sistemi": "Email System",
  "Email Şifresi": "Email Password",
  "Emin misiniz?": "Are you sure?",
  "En Az 5 Dakika fark olmalı": "There must be at least 5 minutes difference",
  "Enter your email and we'll send you instructions to reset your password": "Enter your email and we'll send you instructions to reset your password.",
  "Envanter Ad": "Inventory Name",
  "Etiketle": "Label",
  "Etiketler": "Labels",
  "Etkinlik": "Event",
  "Evet": "Yes",
  "Evet, Sil": "Yes, Delete",
  "Evet, gönder!": "Yes, submit!",
  "Evlilik Tarihi": "Marriage Date",
  "Excel İndir": "Download Excel",
  "Excel'e Aktar": "Export to Excel",
  "Eğitim": "Education",
  "Fakülte": "Faculty",
  "Filtrele": "Filter",
  "Firma": "Company",
  "Forgot Password?": "Forgot Password?",
  "Fotoğraf": "Photo",
  "Fotoğraf İşlemleri": "Photo Operations",
  "Fırtına": "Storm",
  "GPS Yok": "No GPS",
  "Gece": "Night",
  "Geen gegevens gevonden": "No data found",
  "Genel": "General",
  "Genel Bilgi": "General Information",
  "Genel Durum Aylık Rapor": "General Status Monthly Report",
  "Geçersiz doğrulama kodu.": "Invalid verification code.",
  "Giriş": "Entrance",
  "Gizle": "Hide",
  "Gönder": "Send",
  "Gün": "Day",
  "Günaydın ☀️": "Good Morning ☀️",
  "Güncelle": "Update",
  "Gündüz": "Day",
  "Günün Tamamlanması": "Day Completion",
  "Günün İlerlemesi": "Day Progress",
  "Hafif Kar": "Light Snow",
  "Hafif Yağmur": "Light Rain",
  "Hafif Çiseleme": "Light Drizzle",
  "Hafta": "Week",
  "Hava Açık": "Clear Sky",
  "Hava Durumu": "Weather",
  "Hava durumu bilgisi alınamadı.": "Weather information could not be retrieved.",
  "Hava durumu servisine erişilemedi.": "Weather service unreachable.",
  "Hava durumu verisi alınamadı.": "Weather data could not be retrieved.",
  "Hayır": "No",
  "Henüz anket bulunmuyor.": "Henüz anket bulunmuyor.",
  "Henüz cevap bulunmuyor.": "No answers yet.",
  "Henüz cevap yok.": "No answers yet.",
  "Her hakkı saklıdır": "All rights reserved",
  "Hissedilen": "Feels Like",
  "Home": "Home",
  "Hour Types": "Hour Types",
  "Hours Type": "Hour Type",
  "Hoşgeldiniz {name}": "Welcome {name}",
  "IBAN": "IBAN",
  "Inkomende Documenten": "Incoming Documents",
  "KABLO": "CABLE",
  "KOLTUK": "SEAT",
  "KYS Paneli": "QMS Panel",
  "Kalan Ücretli İzin Günü": "Remaining Paid Leave Days",
  "Kalan İzin": "Remaining Leave",
  "Kan Grubu": "Blood Type",
  "Kanban": "Kanban",
  "Kapat": "Close",
  "Kar Yağışlı": "Snowy",
  "Kategori Doküman Takip": "Document Tracking Categories",
  "Katılım Sayısı": "P. Count",
  "Katılım detayları yüklenemedi.": "Error loading details.",
  "Katılım silindi.": "Participation deleted.",
  "Katılımlar yüklenirken hata oluştu.": "Error loading responses.",
  "Kaydet": "Save",
  "Kayıt": "Record",
  "Kayıt Yok!": "No Record Found!",
  "Kimlik No": "ID Number",
  "Kod": "Code",
  "Kod Proje": "Project Code",
  "Kod daha önceden kayıt edilmiş.": "The code has already been registered.",
  "Konu": "Subject",
  "Konum Aranıyor...": "Searching Location...",
  "Konum Bekleniyor...": "Waiting for Location...",
  "Konum Bulunuyor...": "Finding Location...",
  "Konum Hesaplanıyor...": "Calculating Location...",
  "Konum alınamadı.": "Location could not be retrieved.",
  "Konum bilgisi alınamadı": "Location information not found",
  "Konum isteği zaman aşımına uğradı.": "Location request timed out.",
  "Konumu Güncelle": "Update Location",
  "Konumu Yenile": "Refresh Location",
  "Konumu Şimdi Kontrol Et": "Check Location Now",
  "Kopyala": "Copy",
  "Kullanici": "User",
  "Kullanıcı": "Kullanıcı",
  "Kullanıcı Mesai Süreleri": "User Overtime Durations",
  "Kurum/Okul": "Institution/School",
  "Kırağı / Sis": "Freezing Fog",
  "Laravel Log": "Laravel Log",
  "Liste Döküman Takip": "Document Tracking List",
  "Listeye Dön": "Back to List",
  "MASA": "TABLE",
  "MONİTÖR": "MONITOR",
  "MOUSE": "MOUSE",
  "MUTFAK": "KITCHEN",
  "Mail Sistemi": "Mail System",
  "Medeni Durum": "Marital Status",
  "Mesai": "Overtime",
  "Metin girilmedi": "No text entered",
  "Metre": "Meter",
  "Miktar": "Quantity",
  "Minimum 8 karakter uzunluğunda, büyük harf ve sembol !@#$%&*()": "Minimum 8 characters long, uppercase and symbol !{'@'}#$%&*()",
  "Müşteri": "Customer",
  "NETWORK": "NETWORK",
  "NOTEBOOK": "NOTEBOOK",
  "Nem": "Humidity",
  "No data available": "No data available",
  "Not": "Note",
  "Oluştur": "Create",
  "Oluşturulma": "Created At",
  "Onay Tarih": "Approval Date",
  "Otomatik hesaplanır (veya 1'den başlar)": "Calculated automatically (or starts from 1)",
  "Overall": "Overall",
  "Overall Rapor Aylık": "Overall Report Monthly",
  "PC": "PC",
  "PDF oluşturulurken hata": "Error creating PDF.",
  "Paket": "Package",
  "ParaTür": "Currency Type",
  "Parçalı Bulutlu": "Partly Cloudy",
  "Pasif Kayıt": "Passive Record",
  "Pasif/Süresi Dolmuş": "Passive/Expired",
  "Password": "Password",
  "Performans": "Performance",
  "Personel": "Staff",
  "Personel Profil2": "Personnel Profile 2",
  "Pertentage Opa Rapor": "Percentage OPA Report",
  "Pertentage Oparator Rapor -": "Percentage Operator Report -",
  "Pertentage Rapor": "Percentage Report",
  "Proje": "Project",
  "Proje Alt": "Sub-Project",
  "Proje Tanıtım": "Project Definitions",
  "Proje-Paket": "Project-Package",
  "Projealt": "Sub-Project",
  "Puan": "Score",
  "Puan güncellendi.": "Score updated.",
  "Rapor Overall -": "Report Overall -",
  "Rapor Proje -": "Project Report -",
  "Raporlar": "Reports",
  "Rüzgar": "Wind",
  "SANDALYE": "CHAIR",
  "STAND": "STAND",
  "Saat": "Hour",
  "Sabit Zaman": "Fixed Time",
  "Saniye": "Second",
  "ScheduleMonitor": "ScheduleMonitor",
  "Seçenek Ekle": "Add Option",
  "Seçenek metni": "Option text",
  "Seçenekler": "Options",
  "Seçili Konum": "Selected Location",
  "Seçmeli sorularda en az 2 seçenek olmalıdır.": "Choice questions must have at least 2 options.",
  "Shortcut": "Shortcut",
  "Shortcut already exists": "Shortcut already exists",
  "Sicil No": "Employee ID",
  "Sil": "Delete",
  "Silme Onayı": "Delete Confirmation",
  "Sisli": "Foggy",
  "Son Hareket": "Last Action",
  "Son Kontrol": "Last Check",
  "Son güncel": "Last Updated",
  "Sonuçlar": "Results",
  "Soru": "Question",
  "Soru Bazlı Analiz": "Question-based Analysis",
  "Soru Ekle": "Add Question",
  "Soru Metni": "Question Text",
  "Soru Sayısı": "Q. Count",
  "Soru Tipi": "Question Type",
  "Spam'e Taşı": "Move to Spam",
  "Status": "Status",
  "Süre": "Duration",
  "Sıra": "Order",
  "TV": "TV",
  "Takip Kod": "Tracking Code",
  "Takvim": "Calendar",
  "Takvim Doğum Günü Göster": "Show Birthday in Calendar",
  "Tamamlanma Tarihi": "Completion Date",
  "Tanıtım": "Introduction",
  "Tarayıcı desteği yok.": "Browser not supported.",
  "Tarih": "Date",
  "Tarih Aralığı": "Date Range",
  "Taslak": "Draft",
  "Taşı": "Move",
  "Tek Seçmeli": "Single Choice",
  "Tek Seçmeli (Radyo)": "Single Choice (Radio)",
  "Telefon": "Phone",
  "Temizle": "Clean",
  "Teslim Tarih": "Delivery Date",
  "Teşekkürler!": "Thank you!",
  "Tip": "Type",
  "Toplam Cevap": "Total Answers",
  "Toplam Katılımcı": "Total Participants",
  "Toplam Puan": "Total Score",
  "Toplam Puan:": "Total Score:",
  "Tümü": "All",
  "Tümünü Excel İndir": "Download All Excel",
  "Tünaydın 👋": "Good Afternoon 👋",
  "Tür": "Type",
  "USB ETH": "USB ETH",
  "Undefined variable $tarih": "Undefined variable $tarih",
  "Uygulama çevrimdışı çalışmaya hazır.": "App ready to work offline.",
  "Uygulama İndir": "Download App",
  "Varsayılan": "Default",
  "Veri bulunamadı": "No data found",
  "Veri yükleniyor...": "Loading Data...",
  "Veriliş Tarihi": "Issue Date",
  "WEBCAM": "WEBCAM",
  "Webcam": "Webcam",
  "Word Dosyası Yükle": "Upload Word File",
  "YAZICI": "PRINTER",
  "Yakınlık": "Proximity",
  "Yayında": "Published",
  "Yağmurlu": "Rainy",
  "Yeni Anket Oluştur": "Create New Survey",
  "Yeni Güncelleme Mevcut!": "New Update Available!",
  "Yeni özellikleri ve düzeltmeleri görmek için sayfayı yenileyin.": "Refresh page to see new features and fixes.",
  "Yeni Şifre": "New Password",
  "Yerel": "Local",
  "Yerel Saat": "Local Time",
  "Yerel Saat Dilimi": "Local Timezone",
  "Yetkiniz bulunmuyor. Hata olduğunu düşünüyorsanız Admin'e Bilgi verin.": "You are not authorized. If you think this is an error, please inform the Admin.",
  "Your new password must be different from previously used passwords": "Your new password must be different from previously used passwords.",
  "Yoğun Kar": "Heavy Snow",
  "Yoğun Çiseleme": "Heavy Drizzle",
  "Yönetim": "Management",
  "Yönetim Anket": "Survey Management",
  "Yükleniyor...": "Loading...",
  "Yüzde": "Percentage",
  "Yıl": "Year",
  "Zaman Dilimi": "Timezone",
  "Zorunlu Cevap": "Required Answer",
  "için gün bitimi": "day end for",
  "title alanı gereklidir.": "Title field is required.",
  "welcome": "Welcome {title}! 👋🏻",
  "Çiseleme": "Drizzle",
  "Çocuk Sayısı": "Number of Children",
  "Çok Seçmeli": "Multiple Choice",
  "Çok Seçmeli (Onay Kutusu)": "Multiple Choice (Checkbox)",
  "Çoğunlukla Açık": "Mostly Clear",
  "Özet": "Summary",
  "Öğrenim": "Education Level",
  "Ünvan": "Title",
  "İki Aşamalı Doğrulama (2FA)": "Two-Factor Authentication (2FA)",
  "İlk Hareket": "First Action",
  "İndir": "Download",
  "İnsan Kaynakları": "Human Resources",
  "İptal": "Cancel",
  "İyi Akşamlar 🌇": "Good Evening 🌇",
  "İyi Geceler 🌙": "Good Night 🌙",
  "İzin": "Leave",
  "İzin Hakediş Tarihi": "Leave Entitlement Date",
  "İzin Tür": "Leave Type",
  "İzin Türü": "Leave Type",
  "İzin Verilmedi": "Permission Denied",
  "İzinli Gün": "Leave Day",
  "İş Başlangıç Tarihi": "Start Date of Employment",
  "İş Yeri": "Workplace",
  "İşlem": "Action",
  "İşlemler": "Actions",
  "Şehir Bulunamadı": "City Not Found",
  "Şehir veya Ülke Seçiniz": "Select City or Country",
  "Şiddetli Yağmur": "Heavy Rain",
  "Şifre": "Password",
  "Şifre Değiştir": "Change Password",
  "Şimdi Yenile": "Refresh Now",
  "Şube": "Branch",
  "Zorunlu": "Mandatory",
  "Yeni Kayıt": "New Record",
  "İş Giriş Çıkış Tanımları": "Job Entry Exit Definitions",
  "Kayıt bulunamadı.": "Record not found.",
  "EBYS": "EDMS",
  "Incoming Documents": "Incoming Documents",
  "Onay Bekliyor": "Waiting for Approval",
  "İmzalandı": "Signed",
  "Sevk Edildi": "Dispatched",
  "Tamamlandı": "Completed",
  "Hata oluştu": "An Error Occurred",
  "Kullanıcı Seçiniz": "Select User",
  "konu alanı gereklidir.": "Subject field is required.",
  "Bildirimler": "Notifications",
  "Tümünü Okunmadı Olarak İşaretle": "Mark all as unread",
  "Tümünü Okundu Olarak İşaretle": "Mark all as read",
  "Bildirim Bulunamadı!": "No Notifications Found!",
  "Tüm Bildirimleri Gör": "View All Notifications",
  "Tüm Bildirimler": "All Notifications",
  "Hiç bildiriminiz yok.": "You have no notifications.",
  "Hafif Sağanak Yağış": "Slight Rain Showers",
  "Sağanak Yağış": "Rain Showers",
  "Şiddetli Sağanak Yağış": "Violent Rain Showers",
  "Hafif Dondurucu Çiseleme": "Light Freezing Drizzle",
  "Yoğun Dondurucu Çiseleme": "Dense Freezing Drizzle",
  "Hafif Dondurucu Yağmur": "Light Freezing Rain",
  "Yoğun Dondurucu Yağmur": "Heavy Freezing Rain",
  "Yoğun Kar Yağışlı": "Heavy Snow Fall",
  "Kar Taneleri": "Snow Grains",
  "Hafif Kar Sağanağı": "Slight Snow Showers",
  "Yoğun Kar Sağanağı": "Heavy Snow Showers",
  "Dolu Karışık Fırtına": "Thunderstorm with Hail",
  "Şiddetli Dolu Karışık Fırtına": "Thunderstorm with Heavy Hail",
  "Bu tarihe mesai girilemez.": "Overtime cannot be entered for this date.",
  "Kategoriler": "Categories",
  "Galeri": "Gallery",
  "Belge Bilgi Bankası": "Document Knowledge Base",
  "Organizasyon": "Organization",
  "Organizasyon Başlıkları": "Organization Titles",
  "Personel Dosyaları": "Personnel Files",
  "Mesai Rapor": "Overtime Report",
  "Overall Rapor": "Overall Report",
  "Kullanıcı Yetki Rapor": "User Authorization Report",
  "Fatura AI": "Invoice AI",
  "Destek Talepleri": "Support Requests",
  "Telefon Rehberi": "Phone Book",
  "Bildirim Gönder": "Send Notification",
  "Pertentage Oparator Rapor": "Operator Percentage Report",
  "auth": {
    "Farklı bir hesapla giriş yap": "Login with a different account"
  }
}
